import { DocumentCard, Faq } from 'sections/Resources/FreightTemplates/FreightQuotation/types';

export const documentsCardData: DocumentCard[] = [
  {
    id: 1,
    iconName: 'icon-files.svg',
    heading: 'Certificate of Origin',
    url: '/resources/freight-templates/certificate-of-origin',
    fileName: 'certificate_of_origin',
  },
  {
    id: 2,
    iconName: 'icon-files.svg',
    heading: 'Proforma Invoice',
    url: '/resources/freight-templates/proforma-invoice',
    fileName: 'proforma_invoice',
  },
  {
    id: 3,
    iconName: 'icon-files.svg',
    heading: 'Commercial Invoice',
    url: '/resources/freight-templates/commercial-invoice',
    fileName: 'commercial_invoice',
  },
];

export const faq: Faq[] = [
  {
    id: "1",
    question: "Why does the validity date matter so much?",
    answer: (cn: Function) => (
      `
        <p class='${cn('faq__answer-paragraph')}'>
          Freight rates are volatile. A rate valid today might be gone next week due to a GRI (General Rate Increase). A clear validity date protects you from having to honor an old, cheap rate in a new, expensive market.
        </p>
      `
    ),
  },
  {
    id: "2",
    question: "What is the difference between Chargeable Weight and Gross Weight?",
    answer: (cn: Function) => (
      `
        <p class='${cn('faq__answer-paragraph')}'>
          Your quote must explain this. You bill on the higher of the two (actual weight vs. volumetric weight). If you don't make this clear on the quote, clients will dispute the invoice when their light, fluffy cargo gets billed by volume.
        </p>
      `
    ),
  },
  {
    id: "3",
    question: "Should I include 'Subject to' clauses?",
    answer: (cn: Function) => (
      `
        <p class='${cn('faq__answer-paragraph')}'>
          Yes. Always include "Subject to space and equipment availability." Just because you quoted a rate doesn't mean the steamship line has a container ready. This manages client expectations.
        </p>
      `
    ),
  },
  {
    id: "4",
    question: "How detailed should the charges be?",
    answer: (cn: Function) => (
      `
        <p class='${cn('faq__answer-paragraph')}'>
          Break it down enough to be transparent, but bundled enough to be simple. Usually, grouping "Origin Charges," "Freight," and "Destination Charges" is the best balance.
        </p>
      `
    ),
  },
];